export default __webpack_public_path__ + "1c7e960268fab6b131384b06824a1be1.png";